import type React from "react"

export const Exit: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Exit</title>
    <path
      d="M5.25 12.5H3C2.15625 12.5 1.5 11.8438 1.5 11V3C1.5 2.1875 2.15625 1.5 3 1.5H5.25C5.65625 1.5 6 1.1875 6 0.75C6 0.34375 5.65625 0 5.25 0H3C1.3125 0 0 1.34375 0 3V11C0 12.6875 1.3125 14 3 14H5.25C5.65625 14 6 13.6875 6 13.25C6 12.8438 5.65625 12.5 5.25 12.5ZM15.7188 6.46875L10.9688 2.28125C10.6562 2 10.2188 1.9375 9.84375 2.09375C9.46875 2.28125 9.25 2.625 9.25 3.03125V4.78125H5.5C4.78125 4.78125 4.25 5.3125 4.25 6.03125V8.03125C4.25 8.71875 4.78125 9.28125 5.5 9.28125H9.25V11C9.25 11.4062 9.46875 11.75 9.84375 11.9375C9.96875 12 10.125 12.0312 10.2812 12.0312C10.5312 12.0312 10.7812 11.9375 10.9688 11.75L15.7188 7.59375C15.9062 7.4375 16 7.25 16 7.03125C16 6.8125 15.9062 6.625 15.7188 6.46875ZM10.75 9.9375V7.75H5.75V6.25H10.75V4.0625L14.0938 7L10.75 9.9375Z"
      fill="#160067"
    />
  </svg>
)
